import analyzeIndexes from './analyze/analyzeIndexes';
import { time, type LogMethod } from './logger';
import type { Database } from './models/database';
import orderBy from './orderBy';

export default function calculateRecommendations(dbs: Database[], log: LogMethod = console.debug) {
  using _ = time(log, 'Calculating recommendations');

  const recommendations = dbs.flatMap((db) =>
    db.collections.flatMap((collection) =>
      analyzeIndexes(collection.indexes).recommendations.map((recommendation) => {
        return {
          collection,
          recommendation,
        };
      }),
    ),
  );

  return orderBy(recommendations, (x) => x.recommendation.savedSize, 'desc');
}
